import PackAssignDropdown from "./PackAssignDropdown";
import "./QuestJournalFilterDropdown.css";

const MODAL_DROPDOWN_Z_INDEX = 2147483100;

export default function QuestJournalFilterDropdown({
  options = [],
  value,
  onChange,
  disabled = false,
  ariaLabel = "Choisir une option",
  variant = "default",
}) {
  return (
    <div
      className={`quest-journal-filter-dropdown quest-journal-filter-dropdown--${variant}${
        disabled ? " quest-journal-filter-dropdown--disabled" : ""
      }`}
    >
      <PackAssignDropdown
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        ariaLabel={ariaLabel}
        matchTriggerWidth
        menuMaxHeight={168}
        menuZIndex={MODAL_DROPDOWN_Z_INDEX}
      />
    </div>
  );
}
